import React from 'react';
import withStyles from "../wrappers/withStyles";

function Support({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
    >
      <g
        fill={color}
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
        transform="translate(-39 -1349) translate(39 1349)"
      >
        <path d="M80 54.14c0-11.66-7.857-21.848-18.937-24.918C60.367 12.99 46.946 0 30.547 0 13.703 0 0 13.703 0 30.547c0 5.49 1.461 10.834 4.236 15.527L.112 60.98l14.908-4.123a30.433 30.433 0 0014.201 4.204C32.291 72.142 42.48 80 54.141 80c4.654 0 9.18-1.24 13.158-3.595l12.588 3.482L76.405 67.3A25.767 25.767 0 0080 54.14zm-64.24-2.35l-8.925 2.468 2.47-8.924-.564-.88a25.772 25.772 0 01-4.053-13.907c0-14.26 11.6-25.86 25.859-25.86 14.259 0 25.86 11.6 25.86 25.86 0 14.259-11.601 25.86-25.86 25.86a25.774 25.774 0 01-13.907-4.055l-.88-.562zm57.405 21.375l-6.623-1.833-.884.576a21.09 21.09 0 01-11.517 3.404c-9.165 0-17.219-5.925-20.072-14.423 14.034-1.618 25.202-12.786 26.82-26.821 8.498 2.854 14.423 10.908 14.423 20.073a21.09 21.09 0 01-3.404 11.517l-.576.884 1.833 6.623z"></path>
        <path d="M30 43.3333333L33.3333333 43.3333333 33.3333333 46.6666667 30 46.6666667z"></path>
        <path d="M35 22.605c0 1.316-.578 2.531-1.628 3.422L27.5 31.01v5.657h5v-3.615l4.248-3.605C38.814 27.693 40 25.2 40 22.605c0-5.113-4.486-9.272-10-9.272s-10 4.16-10 9.272h5c0-2.556 2.243-4.636 5-4.636s5 2.08 5 4.636z"></path>
      </g>
    </svg>
  );
}

Support.defaultProps = {
  color: 'white',
};

export default withStyles(Support);
